module.exports = __webpack_public_path__ + "static/peppers-5ef72791d2a007bb2196c82eba3adee7.jpeg";